var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.049 11.7l-1.234 1.293 3.82 3.644c1.117 1.058-.705 3.174-1.94 2.057l-3.702-3.82-3.586 3.761c-1.175 1.234-3.35-.94-2.057-2.116l3.82-3.526-.822-.823c-.94-.118-2.116-.059-2.88-.764L3 7.879 6.88 4l3.467 3.527c.764.764.705 1.94.823 2.997l.823.764 1.293-1.234c-.588-1.47 0-3.233 1.116-4.35 1.411-1.41 3.88-1.94 5.349-.47 1.47 1.47.94 3.88-.529 5.29-1.058 1.058-2.704 1.705-4.173 1.176zm-1.528 1.645l-1.234 1.235 3.644 3.82c.881.705 2.174-.764 1.41-1.47l-3.82-3.585zm-3.057-.646l1.235-1.117-.94-.882c-.118-.94 0-2.233-.706-2.88L6.88 4.588l-.47.47 2.645 2.645c.235.235-.235.705-.53.47L5.94 5.528l-.47.47 2.586 2.586c.294.294-.235.765-.47.53L4.997 6.468l-.47.47 2.586 2.645c.294.235-.235.705-.47.47L4 7.409l-.411.47 3.174 3.233c.646.646 1.88.529 2.82.646l.882.94zm6.818-7.288c-1.94 1.116-2.703 2.35-2.762 3.585-.882-1.705 1.234-3.41 2.762-3.585zm2.116.117c1.176 1.176 1 3.292-.47 4.702-1.175 1.176-2.762 1.528-3.997 1L8.113 18.34c-.822.823-2.292-.764-1.469-1.47l7.17-6.7c-.646-1.175-.352-2.938.882-4.173 1.47-1.41 3.586-1.645 4.702-.47z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.4
  }))));
}
export default SvgRestro;